<div class="p-4 md:p-6" *ngIf="currentRates">

  <!-- Info cards + botones -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5">
    <div class="flex flex-wrap gap-3">
      <div style="display: inline-flex; align-items: center; gap: 6px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 8px 14px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">attach_money</mat-icon>
        <span style="font-size: 0.8rem; font-weight: 600; color: #1e5a3f;">USD-CLP</span>
        <span style="font-size: 0.85rem; font-weight: 800; color: #1C593D;">{{ currentRates.data.tasaCLP | number : "1.2-2" }}</span>
      </div>
      <div style="display: inline-flex; align-items: center; gap: 6px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px; padding: 8px 14px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">percent</mat-icon>
        <span style="font-size: 0.8rem; font-weight: 600; color: #1e40af;">Comisión</span>
        <span style="font-size: 0.85rem; font-weight: 800; color: #2563eb;">{{ currentRates.data.porcentajeComision | number : "1.2-5" }}</span>
      </div>
    </div>
    <div class="flex gap-2 flex-wrap">
      <button type="button" (click)="setRates()"
        [disabled]="!puedeEditar"
        [style.opacity]="puedeEditar ? '1' : '0.55'"
        [style.cursor]="puedeEditar ? 'pointer' : 'not-allowed'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">{{ puedeEditar ? 'refresh' : 'lock' }}</mat-icon>
        Actualizar tasas
      </button>
      <button *ngIf="showCopyToClipboard" type="button" (click)="copyMessageToClipboard()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">content_copy</mat-icon>
        Copiar
      </button>
      <p *ngIf="!puedeEditar" class="flex items-center gap-1 w-full" style="font-size: 0.75rem; font-weight: 600; color: #6b7280; margin: 0;">
        <mat-icon aria-hidden="true" style="font-size: 16px; width: 16px; height: 16px;">lock</mat-icon>{{ textoSinPermiso }}
      </p>
    </div>
  </div>

  <!-- Sección Mínimo inferior -->
  <div class="mb-5" *ngIf="limiteInferior">
    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #f59e0b;">trending_down</mat-icon>
      <span style="font-size: 0.9rem; font-weight: 700; color: #374151;">Mínimo {{ limiteInferior }} BS</span>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
      <app-rate-value-card [bank]="'Banesco'" [rateOrigin]="currentRates.data.rate" [imgUrl]="'assets/img/bancos/banesco.png'" [rateDestination]="tasasMin.banesco"></app-rate-value-card>
      <app-rate-value-card [bank]="'Mercantil'" [rateOrigin]="currentRates.data.rate" [imgUrl]="'assets/img/bancos/mercantil.png'" [rateDestination]="tasasMin.mercantil"></app-rate-value-card>
      <app-rate-value-card [bank]="'Provincial'" [rateOrigin]="currentRates.data.rate" [imgUrl]="'assets/img/bancos/provincial.png'" [rateDestination]="tasasMin.provincial"></app-rate-value-card>
      <app-rate-value-card [bank]="'Venezuela'" [rateOrigin]="currentRates.data.rate" [imgUrl]="'assets/img/bancos/venezuela.png'" [rateDestination]="tasasMin.venezuela"></app-rate-value-card>
    </div>
  </div>

  <!-- Sección Mínimo superior -->
  <div *ngIf="limiteSuperior">
    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #16a34a;">trending_up</mat-icon>
      <span style="font-size: 0.9rem; font-weight: 700; color: #374151;">Mínimo {{ limiteSuperior }} BS</span>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
      <app-rate-value-card [bank]="'Banesco'" [rateOrigin]="currentRates.data.rate" [imgUrl]="'assets/img/bancos/banesco.png'" [rateDestination]="tasasMax.banesco"></app-rate-value-card>
      <app-rate-value-card [bank]="'Mercantil'" [rateOrigin]="currentRates.data.rate" [imgUrl]="'assets/img/bancos/mercantil.png'" [rateDestination]="tasasMax.mercantil"></app-rate-value-card>
      <app-rate-value-card [bank]="'Provincial'" [rateOrigin]="currentRates.data.rate" [imgUrl]="'assets/img/bancos/provincial.png'" [rateDestination]="tasasMax.provincial"></app-rate-value-card>
      <app-rate-value-card [bank]="'Venezuela'" [rateOrigin]="currentRates.data.rate" [imgUrl]="'assets/img/bancos/venezuela.png'" [rateDestination]="tasasMax.venezuela"></app-rate-value-card>
    </div>
  </div>

</div>
